import React from 'react';

const TakaIcon: React.FC<{ className?: string; size?: number | string; color?: string }> = ({ className = '', size = 24, color = 'currentColor' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className={className}
  >
    <text
      x="50%"
      y="60%"
      textAnchor="middle"
      fontSize="20"
      fontWeight="bold"
      fill={color}
      fontFamily="'Times New Roman', serif"
      dominantBaseline="middle"
    >
      ৳
    </text>
  </svg>
);

export default TakaIcon; 